/**
 * ==================== ADMIN SHIELD ====================
 * Componente de proteção invisível para rotas admin.
 * 
 * Regras:
 * - Se usuário não está autenticado → 404 (não login)
 * - Se usuário não é admin → 404 (não mostra que existe)
 * - Se usuário é admin → renderiza children
 * 
 * SAFE PATCH: Não modifica backend, apenas protege rotas frontend.
 * ======================================================
 */
import React, { useContext } from 'react';
import { AuthContext } from '@/App';
import NotFound from './NotFound';

export default function AdminShield({ children }) {
  const { user } = useContext(AuthContext);
  
  // Se não está autenticado OU não é admin → 404
  // NÃO mostrar tela de login para não revelar que a rota existe
  if (!user || user.user_type !== 'admin') {
    return <NotFound />;
  }
  
  // Usuário admin autenticado → mostrar conteúdo
  return <>{children}</>;
}
